<template>
  <el-card class="ranking-card">
    <div slot="header" class="clearfix">
      <span>📅 当月帖子排行榜</span>
    </div>
    <div
      v-for="(item, index) in sortedPosts"
      :key="item.id"
      class="post-item"
      @click="handleClick(item)"
    >
      <div class="rank-box">
        <span :class="['rank-number', getRankClass(index)]">
          {{ index + 1 }}
        </span>
      </div>
      <div class="post-content">
        <div class="post-title">{{ item.title }}</div>
        <div class="post-info">
          <span class="author">{{ item.author }}</span>
          <el-divider direction="vertical" />
          <span class="clicks">🔥 {{ item.clicks }}</span>
        </div>
      </div>
      <div class="post-date">{{ formatDate(item.date) }}</div>
    </div>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      posts: [
        {
          id: 1,
          title: "好物分享",
          author: "linava",
          clicks: 2450,
          date: "2024-03-15",
        },
        {
          id: 2,
          title: "生活中不知道的事",
          author: "李四",
          clicks: 1890,
          date: "2024-03-18",
        },
        {
          id: 3,
          title: "该怎么正确给狗狗洗澡",
          author: "张三",
          clicks: 1560,
          date: "2024-03-20",
        },
        {
          id: 4,
          title: "可爱宠物分享",
          author: "王五",
          clicks: 1320,
          date: "2024-03-22",
        },
        {
          id: 5,
          title: "怎么挑选宠物",
          author: "赵六",
          clicks: 980,
          date: "2024-03-25",
        },
        {
          id: 6,
          title: "季度计划通知",
          author: "赵六",
          clicks: 760,
          date: "2024-03-28",
        },
        {
          id: 7,
          title: "季度计划通知",
          author: "赵六",
          clicks: 760,
          date: "2024-03-28",
        },
        {
          id: 8,
          title: "季度计划通知",
          author: "赵六",
          clicks: 760,
          date: "2024-03-28",
        },
        {
          id: 9,
          title: "季度计划通知",
          author: "赵六",
          clicks: 760,
          date: "2024-03-28",
        },
        {
          id: 10,
          title: "季度计划通知",
          author: "赵六",
          clicks: 760,
          date: "2024-03-28",
        },
        {
          id: 11,
          title: "季度计划通知",
          author: "赵六",
          clicks: 760,
          date: "2024-03-28",
        },
      ],
    };
  },

  computed: {
    sortedPosts() {
      return [...this.posts].sort((a, b) => b.clicks - a.clicks);
    },
  },

  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      return `${date.getMonth() + 1}-${date.getDate()}`;
    },

    getRankClass(index) {
      return ["rank-" + (index + 1), { "top-three": index < 3 }];
    },

    handleClick(post) {
      console.log("/detailComPage", post.id);
      this.$router.push("/detailComPage");
    },
  },
};
</script>

<style scoped>
.ranking-card {
  overflow-x: hidden;
  background: linear-gradient(135deg, #ffffff 0%, #f5f7fa 100%);
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  height: 100%;
  border: 1px solid rgba(64, 158, 255, 0.1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.ranking-card >>> .el-card__header {
  padding: 15px 20px;
  border-bottom: 1px dashed #ebeef5;
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  background: linear-gradient(90deg, rgba(64, 158, 255, 0.05), transparent);
}

.ranking-card >>> .el-card__body {
  padding: 0;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.post-item {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  transition: all 0.3s ease;
  cursor: pointer;
  border-bottom: 1px solid #f0f2f5;
  position: relative;
}

.post-item:last-child {
  border-bottom: none;
}

.post-item:hover {
  background-color: #f9fbff;
  transform: translateX(5px);
}

.post-item:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #409eff, transparent);
  transition: width 0.3s ease;
}

.post-item:hover:after {
  width: 100%;
}

.rank-box {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
  flex-shrink: 0;
}

.rank-number {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  transition: all 0.3s;
}

.rank-1 {
  background: #f56c6c;
  color: #fff;
  transform: scale(1.1);
  box-shadow: 0 2px 8px rgba(245, 108, 108, 0.5);
}

.rank-2 {
  background: #e6a23c;
  color: #fff;
  transform: scale(1.05);
  box-shadow: 0 2px 6px rgba(230, 162, 60, 0.5);
}

.rank-3 {
  background: #67c23a;
  color: #fff;
  transform: scale(1);
  box-shadow: 0 2px 6px rgba(103, 194, 58, 0.5);
}

.rank-4,
.rank-5 {
  background: #f0f2f5;
  color: #909399;
}

.post-content {
  flex: 1;
  min-width: 0;
  margin: 0 10px;
}

.post-title {
  font-size: 14px;
  color: #303133;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.3s;
}

.post-item:hover .post-title {
  color: #409eff;
}

.post-info {
  font-size: 12px;
  color: #909399;
  display: flex;
  align-items: center;
}

.author {
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.clicks {
  color: #f56c6c;
  display: flex;
  align-items: center;
}

.clicks:before {
  content: "\e6e0";
  font-family: element-icons !important;
  margin-right: 3px;
  font-size: 12px;
}

.post-date {
  font-size: 12px;
  color: #909399;
  flex-shrink: 0;
}
</style>
